import { api } from '../configs/apiConfig';

const BASE_URL = '/NonOrgPosition';

export const NonOrgPositionService = {
    getAll: async () => {
        const response = await api.get(BASE_URL);
        return response.data;
    },

    getById: async (id) => {
        const response = await api.get(`${BASE_URL}/${id}`);
        return response.data;
    },

    create: async (position) => {
        const response = await api.post(BASE_URL, position);
        return response.data;
    },

    update: async (id, position) => {
        const response = await api.put(`${BASE_URL}/${id}`, position);
        return response.data;
    },

    delete: async (id) => {
        await api.delete(`${BASE_URL}/${id}`);
    }
}; 